// import ally from 'ally.js';

// export let keepFocusInMenu;

/**
 * Get the width of the scrollbar
 */
function getScrollbarWidth() {
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  const root = document.documentElement;

  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Add it as a custom property
  root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

  // Delete the DIV
  document.body.removeChild(scrollDiv);
}

export function getMenuElements() {
  const menuElements = {
    menuToggle: document.querySelector('.js-menu-toggle'),
    overlayMenu: document.querySelector('.js-overlay-menu'),
    body: document.querySelector('body'),
    menuClosers: document.querySelectorAll('.js-menu-close'),
    menuBlur: document.querySelector('.js-menu-blur'),
  };

  return menuElements;
}

function closeOverlayMenu() {
  const { menuToggle, overlayMenu, body, menuBlur } = getMenuElements();

  body.classList.remove('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'false');
  overlayMenu.classList.remove('is-open');
  menuBlur.classList.remove('visible');

  // Allow focus of other elements again
  // keepFocusInMenu.disengage();
  // keepFocusInMenu = null;
}

function openOverlayMenu() {
  const { menuToggle, overlayMenu, body, menuBlur } = getMenuElements();

  body.classList.add('overlay-menu-open');
  menuToggle.setAttribute('aria-expanded', 'true');
  overlayMenu.classList.add('is-open');
  menuBlur.classList.add('visible');

  // Keep focus in menu by making everything else inert
  // keepFocusInMenu = ally.maintain.disabled({
  //   context: root,
  //   filter: overlayMenu,
  // });
}

export function isOverlayMenuOpen() {
  const { body } = getMenuElements();
  const isOpen = body.classList.contains('overlay-menu-open');

  return isOpen;
}

function toggleOverlayMenu() {
  getScrollbarWidth();

  if (isOverlayMenuOpen()) {
    closeOverlayMenu();
  } else {
    openOverlayMenu();
  }
}

// Toggle button
function setupMenuButtons() {
  const { menuToggle, overlayMenu, menuClosers } = getMenuElements();

  if (overlayMenu && menuToggle) {
    menuToggle.addEventListener('click', toggleOverlayMenu);
  }

  // Close buttons
  if (overlayMenu && menuClosers) {
    for (let i = 0; i < menuClosers.length; i++) {
      menuClosers[i].addEventListener('click', closeOverlayMenu);
    }
  }

  // Esc key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOverlayMenuOpen()) {
      closeOverlayMenu();
    }
  });
}

// Hover images
// -------------

function showHoverImage() {
  // Get id
  const id = this.dataset.entryId;

  // find matching image
  const hoverImage = document.querySelector(
    '.js-menu-hover-image[data-id="' + id + '"]'
  );

  if (hoverImage) {
    hoverImage.classList.add('visible');
  }
}

function hideHoverImage() {
  // Get id
  const id = this.dataset.entryId;

  // find matching image
  const hoverImage = document.querySelector(
    '.js-menu-hover-image[data-id="' + id + '"]'
  );

  if (hoverImage) {
    hoverImage.classList.remove('visible');
  }
}

function setupHoverImages() {
  // get hover items
  const hoverItems = document.querySelectorAll('.js-menu-hover-item');

  for (let i = 0; i < hoverItems.length; i++) {
    const hoverItem = hoverItems[i];

    hoverItem.addEventListener('mouseover', showHoverImage);
    hoverItem.addEventListener('mouseleave', hideHoverImage);
  }
}

// ----------------------
// Current page indicator
// ----------------------
function currentPageIndicator() {
  let currentPage = '';
  /* eslint-disable no-undef */
  if (typeof setCurrentPage !== 'undefined') {
    currentPage = setCurrentPage;
  }
  let currentSection = '';
  /* eslint-disable no-undef */
  if (typeof setCurrentSection !== 'undefined') {
    currentSection = setCurrentSection;
  }

  // Add underline to current link
  if (typeof currentPage !== 'undefined' && currentPage) {
    const page = document.querySelector(
      '.js-nav-link[data-slug="' + currentPage + '"]'
    );
    if (page) {
      page.classList.add('is-here');
    }
  }

  // If current section, expand <details> element
  if (typeof currentSection !== 'undefined' && currentSection) {
    const section = document.querySelector(
      '.js-nav-details[data-section="' + currentSection + '"]'
    );
    if (section) {
      section.open = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  getScrollbarWidth();

  setupMenuButtons();

  setupHoverImages();

  currentPageIndicator();
});
